import { FormattedMessage } from 'react-intl';

import styled from 'styled-components';

import { PortfolioInfoIcon } from '../PortfolioInfoIcon';
import { PortfolioTooltip } from '../PortfolioTooltip';
import { PrivacyContextAwareMoneyValue } from '../PrivacyContextAwareMoneyValue';
import { DetailsListFinalItemTypography } from './DetailsListFinalItemTypography';
import { DetailsListItem } from './DetailsListItem';
import { DetailsListLineItem } from './DetailsListLineItem';
import { DetailsListLineItemTypography } from './DetailsListLineItemTypography';

import { APPRECIATION_COLOR } from '../portfolio.constants';

export interface AppreciationDetailsListProps {
  allTimeAppreciation: number;
  initialInvestment: number;
  totalBalance: number;
}

const StyledDetailsListItem = styled(DetailsListItem)`
  &.appreciation {
    align-items: flex-start;
  }

  .text-column {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(0.5)};
  }
`;

export const AppreciationDetailsList = ({
  allTimeAppreciation,
  initialInvestment,
  totalBalance,
}: AppreciationDetailsListProps) => (
  <>
    <DetailsListLineItem value={totalBalance}>
      <FormattedMessage id="total-share-value" defaultMessage="Total Share Value" />
    </DetailsListLineItem>
    <DetailsListLineItem value={initialInvestment}>
      <FormattedMessage id="initial-investment" defaultMessage="Initial Investment" />
    </DetailsListLineItem>
    <StyledDetailsListItem className="appreciation">
      <div className="text-column">
        <PortfolioTooltip
          title={
            <FormattedMessage
              id="appreciation-returns-explanation"
              defaultMessage="We use House Canary, Redfin, and CoreLogic data to estimate the share value of the properties you've invested in. These are unrealized gains."
            />
          }
        >
          <DetailsListFinalItemTypography>
            <FormattedMessage
              id="appreciation-returns"
              defaultMessage="Appreciation Returns {infoIcon}{br} (all time)"
              values={{ infoIcon: <PortfolioInfoIcon />, br: <br /> }}
            />
          </DetailsListFinalItemTypography>
        </PortfolioTooltip>
        <DetailsListLineItemTypography variant="body2">
          <FormattedMessage
            id="appreciation-returns-description"
            defaultMessage="Appreciation will be unrealized until the property is sold."
          />
        </DetailsListLineItemTypography>
      </div>
      <DetailsListFinalItemTypography color={APPRECIATION_COLOR}>
        <PrivacyContextAwareMoneyValue value={allTimeAppreciation} length={4} />
      </DetailsListFinalItemTypography>
    </StyledDetailsListItem>
  </>
);
